/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} What_Is_Land_Skin_DescriptionInputs */

const en_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give the land on your Home, Forest, and Focusing screens a fresh look.`)
};

const ar_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امنح الأرض في الشاشة الرئيسية والغابة وأثناء التركيز مظهرًا جديدًا.`)
};

const de_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib dem Boden auf der Startseite, im Wald und beim Fokussieren einen neuen Look.`)
};

const es_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dale un nuevo aspecto al terreno en Inicio, en el Bosque y durante la concentración.`)
};

const fr_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnez un nouveau look au sol sur l’écran d’accueil, dans la Forêt et en pleine concentration.`)
};

const it_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dai un nuovo aspetto al terreno nella Home, nella Foresta e durante la concentrazione.`)
};

const ja_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ホーム、マイフォレスト、集中中の画面の土地を、新しい見た目に。`)
};

const ko_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`홈, 나의 숲, 집중 중 화면의 땅을 새로운 모습으로 꾸며 보세요.`)
};

const pt_br_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê um novo visual ao terreno no Início, na Floresta e durante o foco.`)
};

const ru_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Придайте земле на главной странице, в лесу и во время концентрации новый облик.`)
};

const th_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปลี่ยนโฉมพื้นดินในหน้าหลัก ป่า และหน้าจอขณะมีสมาธิให้สดใหม่`)
};

const tr_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ana Sayfa, Orman ve odaklanma ekranlarındaki zemine yepyeni bir görünüm kazandır.`)
};

const zh_cn_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为首页、森林与专注画面中的土地，换上全新造型。`)
};

const zh_tw_what_is_land_skin_description = /** @type {(inputs: What_Is_Land_Skin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為首頁、森林與專注畫面的土地，換上全新造型。`)
};

/**
* | output |
* | --- |
* | "Give the land on your Home, Forest, and Focusing screens a fresh look." |
*
* @param {What_Is_Land_Skin_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const what_is_land_skin_description = /** @type {((inputs?: What_Is_Land_Skin_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<What_Is_Land_Skin_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_what_is_land_skin_description(inputs)
	if (locale === "ar") return ar_what_is_land_skin_description(inputs)
	if (locale === "de") return de_what_is_land_skin_description(inputs)
	if (locale === "es") return es_what_is_land_skin_description(inputs)
	if (locale === "fr") return fr_what_is_land_skin_description(inputs)
	if (locale === "it") return it_what_is_land_skin_description(inputs)
	if (locale === "ja") return ja_what_is_land_skin_description(inputs)
	if (locale === "ko") return ko_what_is_land_skin_description(inputs)
	if (locale === "pt_br") return pt_br_what_is_land_skin_description(inputs)
	if (locale === "ru") return ru_what_is_land_skin_description(inputs)
	if (locale === "th") return th_what_is_land_skin_description(inputs)
	if (locale === "tr") return tr_what_is_land_skin_description(inputs)
	if (locale === "zh_cn") return zh_cn_what_is_land_skin_description(inputs)
	return zh_tw_what_is_land_skin_description(inputs)
});